import {
  plateBuilderReducer as plateBuilder,
} from '../api/plate-builder/plate-builder.reducer';

import {
  configurationPanelsInitialState,
  configurationPanelsReducer as configurationPanels, 
} from '../api/configuration-panels';

import {
  configurationValidationReducer as validatedConfiguration,
  validationInitialState,
} from '../api/validation/validation.reducer';

import {
  dynamicTitlesReducer as titles, 
  titlesInitialState,
} from '../api/dynamic-titles/dynamic-titles.reducer';

import {
  localizeReducer as localize,
  localizeInitialState,
} from '../api/localize/localize.reducer';

import {
  queryParameterReducer as queryState,
  queryParameterInitialState,
} from '../api/query-parameter/query-parameter.reducer';

import {
  warningsReducer as warning, warningsInitialState,
} from '../api/warnings/warnings.reducer';

import {
  modalsReducer as modals,
  modalsInitialState,
} from '../app/Container/Modal/Modal.reducer';

export const defaultReducer = {
  plateBuilder,
  configurationPanels,
  localize,
  modals,
  queryState,
  titles,
  validatedConfiguration,
  warning,
};

export const defaultReducerInitialState = {
  plateBuilder: null,
  configurationPanels: configurationPanelsInitialState,
  localize: localizeInitialState,
  modals: modalsInitialState,
  queryState: queryParameterInitialState,
  titles: titlesInitialState,
  validatedConfiguration: validationInitialState,
  warning: warningsInitialState,
}